var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKnowledgeBase = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.148 22.414",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    fill: "none",
    stroke: "#373894",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    transform: "translate(-6.301 -4.405)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3190",
    d: "M23.858 14.316V5.405H8.988a1.687 1.687 0 00-1.687 1.687v16.645"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3191",
    d: "M14.017 25.381H8.945a1.644 1.644 0 01-1.644-1.644h0a1.644 1.644 0 011.644-1.646h6.925"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 311",
    d: "M10.544 8.496v13.596"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 294",
    cx: 2.919,
    cy: 2.919,
    r: 2.919,
    transform: "translate(19.612 17.997)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 312",
    d: "M17.741 25.405l2.493-2.493"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKnowledgeBase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/knowledge_base.88810627be18c71f6f86b2214159c74a.svg";